<template>
  <div class="ColorPicker">
    <el-color-picker
      ref="picker"
      v-model="value"
      :showAlpha="showAlpha"
      color-format="hex"
      @change="changeColor"
      :predefine="predefineColors"
      :disabled="disabled"
    >
    </el-color-picker>
  </div>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    stopPropagation: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: '#1E90FF'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showAlpha: {
      type: Boolean,
      default: true
    }
  },
  // computed:{

  // }
  components: {},
  data () {
    return {
      // color: '#1e90ff',
      predefineColors: [
        '#92D0F8',
        '#70A7EB',
        '#4F7FDF',
        '#70BEE2',
        '#71CFDB',
        '#2DD1E6',
        '#6BCE99',
        '#559B85',
        '#BFF3B4',
        '#F2E593',

        '#EBADA2',
        '#F7BA8D',
        '#F49673',
        '#E56571',
        '#DF6C8D',
        '#C39CE1',
        '#C565F5',
        '#818DD4',
        '#6754BD',
        '#5659F7'
      ]
    }
  },
  methods: {
    changeColor () {
      // const newVal = Cesium.Color.fromCssColorString(this.value).toCssHexString().toUpperCase()
      const newVal = this.value
      this.$emit('input', newVal)
      this.$emit('changeColor', newVal)
    }
  },
  filters: {},
  mounted () {
    if (
      this.stopPropagation &&
      this.$refs.picker &&
      this.$refs.picker.$refs.dropdown
    ) {
      this.$refs.picker.$refs.dropdown.$el.addEventListener(
        'mousedown',
        (event) => {
          event.stopPropagation()
        }
      )
    }
  }
}
</script>

<style lang="scss">
.ColorPicker {
  width: 20px;
  height: 20px;
  .el-color-picker {
    width: 100%;
    height: 100%;
    .el-color-picker__trigger {
      width: 100%;
      height: 100%;
      padding: 2px;
    }
    .el-color-picker__icon {
      display: none;
    }
    .el-color-picker__mask {
      height: 18px;
      width: 18px;
    }
  }
}
</style>
